export default {
    async created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {}
}
